import Header from '../Header/Header'
import contactushero from '../../../assets/images/contactus/contactushero.webp'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const ContactUsHeroSection = () => {
  return (
    <CommonHeroSection
      wrapperClassName="relative overflow-hidden"
      contentClassName="relative z-20 w-full"
    >
      <div className="relative z-20">
        <Header />
      </div>

      <div className="relative z-10 mx-auto grid w-full grid-cols-1 items-end gap-6 pt-12 pb-5 md:pb-0 md:grid-cols-[1.05fr_1fr]">

        {/* MOBILE + TABLET CONTENT */}
        <div className="flex flex-col  text-center md:hidden">

          {/* H1 */}
          <h1 className="mb-6 px-6 font-rajdhani text-4xl font-bold text-white sm:text-5xl md:text-6xl">
            Let Us Discuss What You Are Building
          </h1>

          {/* IMAGE */}
          <div className="flex justify-center">
            <img
              src={contactushero}
              alt="Contact us"
              className="h-auto w-full max-w-full rounded-t-3xl object-cover object-bottom sm:max-w-[420px] md:max-w-[520px]"
            />
          </div>

          {/* PARA */}
          <p className="mt-6 px-6 font-gilroy-medium text-base leading-relaxed text-gray-300 sm:text-lg md:text-xl">
            No sales pitch. No pressure. Just a straightforward conversation
            about your technical challenges and whether The Coding Studio is the
            right partner to help you solve them. If we are not the right fit,
            we will tell you - and point you toward someone who might be.
          </p>
        </div>

        {/* LAPTOP VIEW */}
        <div className="hidden md:contents">

          {/* IMAGE */}
          <div className="relative flex h-full items-end justify-start overflow-hidden">
            <img
              src={contactushero}
              alt="Contact us"
              className="h-full w-[650px] rounded-t-3xl object-cover object-bottom xl:w-[650px] 2xl:w-[800px]"
            />
          </div>

          {/* TEXT */}
          <div className="mx-auto flex h-full w-[80%] flex-col items-start justify-end pb-14 text-start lg:items-start lg:pb-20 lg:text-left 2xl:justify-center">
            <h1 className="mb-4 font-rajdhani text-4xl font-bold text-white lg:text-4xl xl:text-5xl 2xl:text-7xl">
              Let Us Discuss What You Are Building
            </h1>

            <p className="max-w-[65ch] font-gilroy-medium text-base leading-relaxed text-gray-300 lg:text-xl xl:text-xl 2xl:text-2xl">
              No sales pitch. No pressure. Just a straightforward conversation
              about your technical challenges and whether The Coding Studio is
              the right partner to help you solve them. If we are not the right
              fit, we will tell you - and point you toward someone who might be.
            </p>
          </div>

        </div>
      </div>
    </CommonHeroSection>
  )
}

export default ContactUsHeroSection